import React from 'react';
import { CheckCircle2Icon, LockIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { PaymentBadges } from './PaymentBadges';
import { IMAGES, PRICES, PAYMENT_LINK } from '../utils/constants';
export function OfferSection() {
  const mainItems = ['Metodo Lezioni Musicali Coinvolgenti', 'Psicologia della Motivazione Musicale', 'Sistema di Progresso per Studenti di Musica', 'Attività e Dinamiche per Insegnanti di Musica', 'Il Metodo del Professore di Musica Moderno'];
  const bonusItems = ['Planner Professionale per Lezioni di Musica', 'Checklist della Lezione Perfetta', 'Mini Sistema di Fidelizzazione Studenti', 'Piano Rapido di Motivazione per Allievi Musicali'];
  return <section id="oferta" className="py-16 md:py-24 px-4 bg-gradient-to-b from-gray-50 to-white scroll-mt-20" data-id="element-140">
      <div className="max-w-2xl mx-auto" data-id="element-141">
        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden relative" data-id="element-142">
          {/* Header */}
          <div className="bg-green-500 text-white text-center py-4 px-6" data-id="element-143">
            <h2 className="text-2xl md:text-3xl font-bold uppercase tracking-wide" data-id="element-144">
              Accedi Ora al MegaPack
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-145">
            {/* Mini Fan Image */}
            <div className="relative h-[150px] flex items-center justify-center mb-8" data-id="element-146">
              <img src={IMAGES.TOMO_2} className="absolute w-[15%] left-[20%] -rotate-12 shadow-md rounded-sm" alt="" data-id="element-147" />
              <img src={IMAGES.TOMO_3} className="absolute w-[18%] left-[30%] -rotate-6 shadow-md z-10 rounded-sm" alt="" data-id="element-148" />
              <img src={IMAGES.TOMO_5} className="absolute w-[18%] right-[30%] rotate-6 shadow-md z-10 rounded-sm" alt="" data-id="element-149" />
              <img src={IMAGES.TOMO_2} className="absolute w-[15%] right-[20%] rotate-12 shadow-md rounded-sm" alt="" data-id="element-150" />
              <img src={IMAGES.TOMO_1} className="absolute w-[25%] z-20 shadow-xl rounded-sm" alt="" data-id="element-151" />
            </div>

            {/* Value List */}
            <div className="space-y-3 mb-8" data-id="element-152">
              {mainItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-153">
                  <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-154" />
                  <span className="text-gray-800 font-medium" data-id="element-155">{item}</span>
                </div>)}
              <div className="border-t border-gray-100 my-4" data-id="element-156"></div>
              {bonusItems.map((item, i) => <div key={`bonus-${i}`} className="flex items-start gap-3" data-id="element-157">
                  <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-158" />
                  <span className="text-gray-800 font-medium flex-grow" data-id="element-159">
                    {item}
                  </span>
                  <span className="bg-red-600 text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase tracking-wider flex-shrink-0 mt-0.5" data-id="element-160">
                    GRATIS
                  </span>
                </div>)}
            </div>

            {/* Pricing Area */}
            <div className="text-center bg-gray-50 rounded-2xl p-6 mb-8 border border-gray-100" data-id="element-161">
              <div className="flex flex-col items-center justify-center gap-1 mb-4 text-gray-500 font-medium" data-id="element-162">
                <span data-id="element-163">
                  Valore totale reale:{' '}
                  <span className="line-through" data-id="element-164">{PRICES.totalValue}</span>
                </span>
                <span data-id="element-165">
                  Prezzo originale:{' '}
                  <span className="line-through decoration-red-500 decoration-2" data-id="element-166">
                    {PRICES.original}
                  </span>
                </span>
              </div>

              <p className="text-gray-800 font-bold mb-2" data-id="element-167">Oggi tuo a soli</p>
              <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-168">
                <span className="text-5xl md:text-6xl font-extrabold text-gray-900" data-id="element-169">
                  {PRICES.sale.replace(' €', '')}
                </span>
                <span className="text-3xl font-bold text-gray-500" data-id="element-170">€</span>
              </div>

              <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-1.5 rounded-full text-sm mt-2" data-id="element-171">
                💚 Risparmi l'{PRICES.savings} oggi
              </div>
            </div>

            {/* Countdown */}
            <div className="mb-8 flex justify-center" data-id="element-172">
              <CountdownTimer variant="dark" data-id="element-173" />
            </div>

            {/* CTA Button */}
            <a href={PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="block w-full bg-green-500 hover:bg-green-600 text-white text-center text-2xl py-6 rounded-2xl font-bold shadow-lg shadow-green-500/30 animate-pulse-fast transition-all transform hover:scale-[1.02]" data-id="element-174">
              🟢 ACQUISTA ORA
            </a>

            <PaymentBadges data-id="element-175" />
          </div>
        </div>

        {/* Trust Box */}
        <div className="bg-green-50 rounded-xl p-6 mt-8 border border-green-100" data-id="element-176">
          <div className="space-y-4" data-id="element-177">
            <div className="flex items-start gap-4" data-id="element-178">
              <LockIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-179" />
              <div data-id="element-180">
                <h4 className="font-bold text-gray-900" data-id="element-181">
                  Transazione Sicura al 100%
                </h4>
                <p className="text-sm text-gray-600" data-id="element-182">
                  Protetto con crittografia SSL a 256 bit
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-183">
              <ShieldIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-184" />
              <div data-id="element-185">
                <h4 className="font-bold text-gray-900" data-id="element-186">Garanzia 45 Giorni</h4>
                <p className="text-sm text-gray-600" data-id="element-187">
                  Soddisfatti o rimborsati. Nessun rischio.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-188">
              <CreditCardIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-189" />
              <div data-id="element-190">
                <h4 className="font-bold text-gray-900" data-id="element-191">Pagamento Unico</h4>
                <p className="text-sm text-gray-600" data-id="element-192">
                  Nessun abbonamento. Nessun costo nascosto.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* What happens next */}
        <div className="bg-gray-100 rounded-xl p-6 mt-6 border border-gray-200" data-id="element-193">
          <h3 className="font-bold text-gray-900 text-center mb-4" data-id="element-194">
            Cosa succede dopo l'acquisto?
          </h3>
          <ol className="space-y-3" data-id="element-195">
            <li className="flex gap-3 text-sm text-gray-700" data-id="element-196">
              <span className="font-bold text-gray-900 bg-white w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-197">
                1
              </span>
              Completi il pagamento in modo sicuro
            </li>
            <li className="flex gap-3 text-sm text-gray-700" data-id="element-198">
              <span className="font-bold text-gray-900 bg-white w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-199">
                2
              </span>
              Ricevi subito l'accesso al materiale digitale
            </li>
            <li className="flex gap-3 text-sm text-gray-700" data-id="element-200">
              <span className="font-bold text-gray-900 bg-white w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-201">
                3
              </span>
              Inizi immediatamente a usare il sistema nelle tue lezioni
            </li>
          </ol>
        </div>
      </div>
    </section>;
}